import { IMakePayment, IPayment, IPaymentMethod } from '@app/types';
import React from 'react';
import GeneralPayment from './general-payment';
import StripePayment from './stripe-payment';

interface IProps {
    payment: IPayment;
    selectedPaymentMethod: IPaymentMethod;
    currency: string;
    onMakePayment: (payment: IMakePayment) => void;
}

const PaymentGateway: React.FC<IProps> = (props) => {
    const { payment, selectedPaymentMethod, currency, onMakePayment } = props;

    if (!payment || payment.total > 0 && !selectedPaymentMethod) {
        return null;
    }

    if (payment.total == 0) {
        return <GeneralPayment
            payment={payment}
            selectedPaymentMethod={null}
            onMakePayment={onMakePayment}
        />;
    }
    switch (selectedPaymentMethod.name.toLowerCase()) {
        case 'stripe':
            return <StripePayment
                payment={payment}
                selectedPaymentMethod={selectedPaymentMethod}
                currency={currency}
                onMakePayment={onMakePayment} />;
        case 'banktransfer':
        case 'easypay':
        case 'saferpay':
        case 'epay':
        case 'paypalexpress':
        case 'gocardless':
        case 'instore':
        case 'voucher':
        case 'cloverconnect':
        case 'ponchopay':
        case 'takepayments':
            return <GeneralPayment
                payment={payment}
                selectedPaymentMethod={selectedPaymentMethod}
                onMakePayment={onMakePayment}
            />;
    }

    return null;
};

export default PaymentGateway;